<script setup lang="ts">
import { ref, provide } from 'vue'
import { RouterView } from 'vue-router'
import ToastComponent from './components/ToastComponent.vue'
import { TOAST_DURATION } from './constants/toast'

const toastVisible = ref(false)
const toastType = ref<'success' | 'warning' | 'error'>('success')
const toastMessage = ref('')

function showToast(type: 'success' | 'warning' | 'error', message: string) {
  toastType.value = type
  toastMessage.value = message
  toastVisible.value = true

  setTimeout(() => {
    toastVisible.value = false
  }, TOAST_DURATION.global)
}
// 提供全局方法，任何页面都可以 inject('showToast') 来使用
provide('showToast', showToast)
</script>

<template>
  <RouterView />
  <div class="global-toast">
    <ToastComponent :visible="toastVisible" :type="toastType" :message="toastMessage" />
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  background: #f5f6fb;
}

#app {
  width: 100%;
  min-height: 100vh;
  background: #f5f6fb;
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.login-page {
  display: flex;
  width: 100%;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.global-toast {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  pointer-events: none;
}
</style>
